import { render, staticRenderFns } from "./LunchVacationBox.vue?vue&type=template&id=f2ba8fd6&scoped=true&"
import script from "./LunchVacationBox.vue?vue&type=script&lang=js&"
export * from "./LunchVacationBox.vue?vue&type=script&lang=js&"
import style0 from "./LunchVacationBox.vue?vue&type=style&index=0&id=f2ba8fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ba8fd6",
  null
  
)

export default component.exports